import { render, staticRenderFns } from "./AlarmMissModify.vue?vue&type=template&id=2f72dfcc&scoped=true&"
import script from "./AlarmMissModify.vue?vue&type=script&lang=js&"
export * from "./AlarmMissModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72dfcc",
  null
  
)

export default component.exports